import { DefaultWidgetNames, WidgetSlotConfiguration, WidgetType } from '@/api/rest/resources/types/widget';
import { usePlotGroupWithoutGrouping } from '@/components/PlotGroups/PlotGroupsContextProvider';
import { useDashboardOrganizationSummary } from '@/hooks/useDashboardOrganizationSummary';

export const useTotalAssets = () => {
  const plotGroupId = usePlotGroupWithoutGrouping()?.id;

  const { total_assets: totalAssets } = useDashboardOrganizationSummary(undefined, plotGroupId).data ?? {};
  const formattedValue = totalAssets ?? 0;

  return {
    name: DefaultWidgetNames.default_total_assets_card,
    type: WidgetType.o_card,
    visible: true,
    relatedData: {
      styles: {
        root: 'min-w-[200px] grow lg:basis-1/4 rounded-3xl',
        body: 'flex flex-col gap-4 p-8',
      },
    },
    widgets: [
      {
        name: 'total_assets_header',
        type: WidgetType.a_text,
        visible: true,
        widgets: [
          {
            name: 'total_assets_header_text',
            type: WidgetType.a_text,
            visible: true,
            relatedData: {
              i18nPath: 'global.widget.totalAssets',
              className: 'typography-body1 text-text-primary',
            },
          },
          {
            name: 'total_assets_header_tooltip',
            type: WidgetType.m_tooltip,
            visible: true,
            relatedData: {},
            widgets: [
              {
                name: 'total_assets_header_tooltip_trigger',
                type: WidgetType.m_tooltip_trigger,
                visible: true,
                widgets: [
                  {
                    name: 'total_assets_header_tooltip_trigger_icon',
                    type: WidgetType.a_icon,
                    visible: true,
                    relatedData: {
                      icon: 'ri-information-line',
                      className: 'ml-1 text-active-54',
                    },
                  },
                ],
              },
              {
                name: 'total_assets_header_tooltip_content',
                type: WidgetType.m_tooltip_content,
                visible: true,
                widgets: [
                  {
                    name: 'total_assets_header_tooltip_text',
                    type: WidgetType.a_text,
                    visible: true,
                    relatedData: {
                      i18nPath: 'global.widget.totalAssetsTooltip',
                    },
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        name: 'total_assets_value',
        type: WidgetType.a_text,
        visible: true,
        relatedData: {
          text: formattedValue,
          className: 'typography-h2 text-text-primary',
        },
      },
    ],
  } as WidgetSlotConfiguration;
};
